module.exports = __webpack_public_path__ + "img/1479154346.29919c26.jpg";